import { Moment } from 'moment';
import { IUser } from 'spw-redux/modules/user/types';
import { FileType } from 'spw-redux/modules/reports/types';

export enum DownloadStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  FAILED = 'FAILED',
  DONE = 'DONE',
}

export interface UserDownload {
  download: Download;
  template: DownloadTemplate;
}

export interface DownloadFailedTemplate {
  isNewTemplate: boolean;
  downloadTemplate: DownloadTemplate;
}

export interface DownloadVariantsConfig {
  showClientFacingNames: boolean;
  showRsf: boolean;
  format: 'png' | 'pdf';
}

export interface Download {
  id?: number;
  name: string;
  projectId: number;
  numberOfFiles: number;
  status: DownloadStatus;
  downloadConfigs: DownloadConfig[];
  user?: IUser;
  insertedAt: Moment;
  variants?: DownloadVariantsConfig;
  formatConfigs?: DownloadVariantsConfig[];
}

export interface DownloadVM extends Download {
  isDownloadingZipFile: boolean;
  isDownloadBeingDeleted: boolean;
}

export type DownloadTypes =
  | 'seat_count_analysis'
  | 'summary_calcs'
  | 'worksheet'
  | 'worksheet_with_notes'
  | 'program_summary'
  | 'program_notes';

export type RowsVisibility = {
  shouldRowsShowOpen: boolean;
  shouldRowsShowClosed: boolean;
};

export type DownloadOptions = {
  [key in DownloadTypes]: boolean | RowsVisibility;
};

export type DownloadTemplateVM = {
  id?: number;
  name?: string;
  downloadName?: string;
  user?: IUser;
  insertedAt?: string; // YYYY-MM-DD HH:mm
  config: { [key in FileType]: Record<string | number, DownloadOptions> };
  formatConfigs?: DownloadVariantsConfig[];
};

export type DownloadConfig = {
  downloadConfigType: DownloadTypes;
  detailedConfig?: RowsVisibility | null;
  downloadFileType: FileType;
  scenarioId?: number;
  totalProgramId?: number;
  templateId?: number;
};

export type DownloadTemplate = {
  id?: number;
  name: string;
  projectId: number;
  user?: IUser;
  downloadConfigs: DownloadConfig[];
  insertedAt?: string; // YYYY-MM-DD HH:mm
  formatConfigs?: DownloadVariantsConfig[];
};

export enum SaveTemplateDialogMode {
  Save = 'Save',
  SaveAs = 'SaveAs',
}
